/**
 * Automatic geolocation field (form_attribute_type_id 19).
 *
 * The field captures the visitor's position on its own and stores a plain
 * string — no map, no manual input. The provider below is only used to turn
 * the captured coordinates into a readable address; BANOC is one of them and
 * answers with a cell code rather than a street address, which is why it needs
 * a precision level on top of the provider.
 */
export const GEOLOCATION_PROVIDERS = [
    { value: 'osm', label: 'OpenStreetMap' },
    { value: 'bing', label: 'Bing Maps' },
    { value: 'maps', label: 'Google Maps' },
    { value: 'banoc', label: 'BANOC' }
]

export const DEFAULT_GEOLOCATION_PROVIDER = 'osm'

// Same scale as the radius picker of the location field.
export const BANOC_LEVELS = [
    { value: 180, label: '1 m' },
    { value: 155, label: '5 m' },
    { value: 130, label: '30 m' },
    { value: 105, label: '200 m' },
    { value: 80, label: '1 km' }
]

export const DEFAULT_BANOC_LEVEL = 155

// Public BANOC API — the city picker of a BANOC map field queries it directly.
export const BANOC_API_URL = process.env.VUE_APP_BANOC_API_URL || 'https://dev.api.banoc.coeurduweb.com'
